import { useState, useCallback } from 'react';
import { StuckFilters } from './types';

const initialFilters = (): StuckFilters => ({ facets: {} });

/**
 * Facet filter state for the Stuck Workflow dashboard. Region is fixed by the
 * deployed environment (per-region backend), so it is NOT part of this state.
 */
export function useStuckFilters() {
    const [filters, setFilters] = useState<StuckFilters>(initialFilters);

    const setFacet = useCallback((key: string, values: string[]) => {
        setFilters((f) => ({ ...f, facets: { ...f.facets, [key]: values } }));
    }, []);

    const clearFacets = useCallback(() => {
        setFilters((f) => ({ ...f, facets: {} }));
    }, []);

    const resetAll = useCallback(() => setFilters(initialFilters()), []);

    return { filters, setFacet, clearFacets, resetAll };
}
